import type React from "react";
import {useEffect, useState} from "react";

import {
  CustomBlending,
  MaxEquation,
  OneFactor,
  type Texture,
  TextureLoader,
} from "three";

import {useUniforms} from "~/contexts/uniforms/Uniforms";
import {cld} from "~/firebase/cloudinary";

import vertexShader from "./attractor.vert?raw";
import fragmentShader from "./texture.frag?raw";

const TextureBlackHoleInstanceDefinition: React.FC = () => {
  const [texture, setTexture] = useState<Texture | null>(null);
  const uniforms = useUniforms();

  // Load texture using useEffect and update state
  useEffect(() => {
    const loader = new TextureLoader();
    loader.load(
      cld.image("black-hole-9_x2tdn8").format("auto").quality("auto").toURL(),
      (loadedTexture) => {
        setTexture(loadedTexture);
      },
    );
  }, []);
  // Provide a fallback material while the texture is loading
  if (!texture) {
    return <meshBasicMaterial color="lightGray" attach="material" />;
  }

  return (
    <shaderMaterial
      key={Math.random()}
      attach="material"
      vertexShader={vertexShader}
      fragmentShader={fragmentShader}
      uniforms={{
        ...uniforms,
        uTexture: {
          value: texture,
        },
      }}
      // blending={NormalBlending}
      transparent={true}
      blending={CustomBlending}
      blendSrc={OneFactor}
      blendDst={OneFactor}
      blendEquation={MaxEquation}
    />
  );
};

export default TextureBlackHoleInstanceDefinition;
